import { Box, IconButton, Typography } from "@mui/material";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { useTranslation } from "react-i18next";
import { common } from "../../i18n";

export default function CustomTablePagination({
  count,
  page,
  rowsPerPage,
  onPageChange,
}: {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (newPage: number) => void;
}) {
  const totalPages = Math.ceil(count / rowsPerPage);

  const start = page * rowsPerPage + 1;

  const end = Math.min((page + 1) * rowsPerPage, count);

  const { t, i18n } = useTranslation([common], {
    nsMode: "fallback",
  });

  return (
    <Box display="flex" alignItems="center" justifyContent="flex-end" gap={1}>
      <Typography variant="body1" color={"var(--gray1)"} marginRight={1}>
        {`${start}–${end} ${t("Of")} ${count}`}
      </Typography>

      <Typography variant="body1" color={"var(--gray1)"}>
        {`${t("Page-Of", {
          first: page + 1,
          last: totalPages,
        })}`}
      </Typography>

      <IconButton
        onClick={() => onPageChange(0)}
        disabled={page === 0}
        size="medium"
      >
        <FirstPageIcon fontSize="medium" />
      </IconButton>

      <IconButton
        onClick={() => onPageChange(page - 1)}
        disabled={page === 0}
        size="medium"
      >
        <KeyboardArrowLeft fontSize="medium" />
      </IconButton>

      <IconButton
        onClick={() => onPageChange(page + 1)}
        disabled={page >= totalPages - 1}
        size="medium"
      >
        <KeyboardArrowRight fontSize="medium" />
      </IconButton>

      <IconButton
        onClick={() => onPageChange(totalPages - 1)}
        disabled={page >= totalPages - 1}
        size="medium"
      >
        <LastPageIcon fontSize="medium" />
      </IconButton>
    </Box>
  );
}
